import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  buildStickyWatermarkScope,
  mergeResolvedWithStickyWatermark,
} from "@/components/branding/brandingCacheSync";
import {
  brandingKeys,
  getResolvedBranding,
} from "@/services/api/agentic-v2/branding";
import { useAuth } from "@/context/AuthContext";
import type { EffectiveBranding } from "@/services/api/agentic-v2/types";

export function useResolvedBranding(options?: {
  asUserId?: string;
  surfaceId?: string;
  enabled?: boolean;
}) {
  const { user } = useAuth();
  const { asUserId, surfaceId, enabled = true } = options ?? {};
  const stickyScope = useMemo(
    () => buildStickyWatermarkScope(user),
    [user?.id, user?.company_id],
  );

  return useQuery<EffectiveBranding>({
    queryKey: brandingKeys.resolved(asUserId, surfaceId),
    queryFn: async () =>
      mergeResolvedWithStickyWatermark(
        await getResolvedBranding({ asUserId, surfaceId }),
        stickyScope,
      ),
    enabled,
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
}
